import { useRouterState } from '@tanstack/react-router';

/**
 * Hook that provides the current pathname using TanStack Router.
 * This ensures the sidebar updates when navigating via router.push/navigate.
 * Uses useRouterState which subscribes to router state changes.
 */
export function usePathname(): string {
  const routerState = useRouterState({ select: (s) => s.location.pathname });
  return routerState;
}
